module.exports = __webpack_public_path__ + "static/media/rac.1fecd041.png";